import amexIconUrl from './cardBrandsLogos/amex-icon.svg';
import amexLogoUrl from './cardBrandsLogos/amex-logo.svg';
import defaultLogoUrl from './cardBrandsLogos/default-logo.svg';
import dinersClubIconUrl from './cardBrandsLogos/dinersclub-icon.svg';
import dinersClubLogoUrl from './cardBrandsLogos/dinersclub-logo.svg';
import maestroIconUrl from './cardBrandsLogos/maestro-icon.svg';
import maestroLogoUrl from './cardBrandsLogos/maestro-logo.svg';
import mastercardIconUrl from './cardBrandsLogos/mastercard-icon.svg';
import mastercardLogoUrl from './cardBrandsLogos/mastercard-logo.svg';
import visaIconUrl from './cardBrandsLogos/visa-icon.svg';
import visaLogoUrl from './cardBrandsLogos/visa-logo.svg';
import jcbIconUrl from './cardBrandsLogos/jcb-icon.svg';
import jcbLogonUrl from './cardBrandsLogos/jcb-logo.svg';
import discoverIconUrl from './cardBrandsLogos/discover-icon.svg';
import discoverLogoUrl from './cardBrandsLogos/discover-logo.svg';
import unionpayLogoUrl from './cardBrandsLogos/unionpay-logo.svg';

export const cardBrandsIcons: { [key: string]: string } = {
    'amex-icon': amexIconUrl,
    'amex-logo': amexLogoUrl,
    'default-logo': defaultLogoUrl,
    'dinersclub-icon': dinersClubIconUrl,
    'dinersclub-logo': dinersClubLogoUrl,
    'maestro-icon': maestroIconUrl,
    'maestro-logo': maestroLogoUrl,
    'mastercard-icon': mastercardIconUrl,
    'mastercard-logo': mastercardLogoUrl,
    'visa-icon': visaIconUrl,
    'visa-logo': visaLogoUrl,
    'jcb-icon': jcbIconUrl,
    'jcb-logo': jcbLogonUrl,
    'discover-icon': discoverIconUrl,
    'discover-logo': discoverLogoUrl,
    'unionpay-icon': unionpayLogoUrl,
    'unionpay-logo': unionpayLogoUrl,
};
